import {Component, SimpleChanges} from '@angular/core';
import {XhAnonymizationDataService} from "../../../service/api/xh-anonymization-data.service";
import {PageComponent} from "../../../../../core/shared/mvs-page/page.component";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {ActivatedRoute} from "@angular/router";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {Sorting} from "../../../../../core/shared/misc/sorting";

@Component({
    selector: 'mvs-xx-table-page',
    templateUrl: './xh-anonymize.page.html',
    standalone: false
})
export class XhAnonymizePage extends PageComponent {

  defaultLabel: string = "Anonymize Data";

  widgetData: WidgetData;

  anonymizePersons: boolean = false;
  anonymizePersonDetails: boolean = false;

  anonymizeContacts: boolean = false;
  anonymizeAddresses: boolean = false;

  anonymizeAud: boolean = false;
  anonymizeDocuments: boolean = false;

  constructor(
      protected anonymizationService: XhAnonymizationDataService,
      protected messageHandler: MvsMessageService,
      protected route: ActivatedRoute,
      protected coreService: MvsCoreService) {

    super(route, coreService);
  }

  ngOnInit(): void {

    super.ngOnInit();

    this.initComponent();
    this.refreshComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {

    // this.widgetData = WidgetFactory.createWidgetTableEntity(
    //     "xh.anonymize.page.values",
    //     "Daten für Anonymisierung",
    //     "xh.AnonymizationData",
    //     "Keine Daten vorhanden",
    //     ObjectRequestList.createWithPaging(
    //         true,
    //         [],
    //         [new Sorting("id", false)],
    //         PagingDto.create(0, 20)
    //     )
    // );
      this.widgetData = WidgetFactory.createWidgetTableEntityQl("xh.anonymize.page.values.new", "Daten für Anonymisierung", "xh.AnonymizationData", "Keine Daten vorhanden", [], [
          new Sorting("e.id", false)
      ]);


  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }

  /**
   * Process changes within Binding.
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {

    if (!this.initialized) {
      return;
    }

    if (changes["id"]) {
      this.refreshComponent();
    }
  }

  onAnonymize(event: any) {

    if (this.busy)
      return;

    if (!this.anonymizeAddresses &&
        !this.anonymizePersons &&
        !this.anonymizePersonDetails &&
        !this.anonymizeContacts &&
        !this.anonymizeAud &&
        !this.anonymizeDocuments) {
      this.messageHandler.showErrorMessage("Anonymize", "Please select at least one option");
      return;
    }

    this.busy = true;

    this.anonymizationService.anonymizeData(
        this.anonymizePersons,
        this.anonymizePersonDetails,
        this.anonymizeAddresses,
        this.anonymizeContacts,
        this.anonymizeAud,
        this.anonymizeDocuments).subscribe(value => {
      this.messageHandler.showSuccessMessage("Anonymize", "Data was successfully anonymized");
      this.busy = false;
    }, error => {
      this.messageHandler.showErrorMessage("Anonymize", "Data was not anonymized!");
      this.busy = false;
    });

  }


  /**
   * Destroy component.
   */
  ngOnDestroy(): void {

  }


}
